<template>
    <div class="w-full h-10 bg-red-700 text-white flex justify-center items-center font-bold">
        {{ $t("layouts.impersonating.message") }}&nbsp;-&nbsp;
        <a
            class="cursor-pointer underline"
            @click="leaveImpersonation"
            >{{ $t("layouts.impersonating.leave") }}</a
        >
    </div>
</template>

<script lang="ts" setup>
const baseUrl = useBaseUrl();
const client = useSanctumClient();

const leaveImpersonation = async function () {
    const leaveUrl = `${baseUrl}api/impersonate/leave`;
    const adminUrl = `${baseUrl}admin`;

    await client(leaveUrl, {
        method: "POST",
    });
    window.location.href = adminUrl;
};
</script>
